module.exports = __webpack_public_path__ + "4fd9d1eaecfbc928580d19f3803094a7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/shoes-jester.png
// module id = 1932
// module chunks = 0